
import React from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import { useRouter } from "next/router";

import TerminalScoreProvider from "../../components/scores/TerminalScoreProvider";
import TerminalScoreLoadingGuard from "../../components/scores/TerminalScoreLoadingGuard";
import TerminalDebugger from "../../components/scores/TerminalDebugger";
import GDataBaseProvider from "../../components/graph/GDataBaseProvider";
import PageHeader from "../../components/general/PageHeader";
import SimpleNodeListProvider from "../../components/general/SimpleNodeListProvider";


export default function TerminalScoreDebuggerPage() {
  return (
    <BaseLayout pageTitle="Terminal Score Debugger">
      <GDataBaseProvider>
      <SimpleNodeListProvider>
        <TerminalScoreProvider>
          <PageHeader
            title="Terminal Score Debugger"
            description="Get insights in to your Terminal score and improve your ranking."
          />

          <TerminalScoreLoadingGuard>
            <TerminalDebugger />
          </TerminalScoreLoadingGuard>
        </TerminalScoreProvider>
        </SimpleNodeListProvider>
      </GDataBaseProvider>
    </BaseLayout>
  );
}
